module.exports = __webpack_public_path__ + "static/media/grave.1427acb7.png";